// extracted by mini-css-extract-plugin
export default {"p_content":"b0ec1c0551"};